let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* ===== Blerron cart guard =====
 * Houdt gratis accessoires (producten van €0, of regels die de bundel als cadeau toevoegde)
 * gelijk aan het aantal Blerron Flex / Flex Pro in de winkelwagen: 1 muismat en 1 beschermhoes
 * per Flex, de laptop standaard 1x vanaf 2 sets. Zonder Flex worden ze verwijderd.
 * Werkt met de thema-drawer, de winkelwagenpagina en de Kaching Cart drawer.
 * - FLEX_PRODUCT_IDS: producten die recht geven op gratis accessoires
 * - GIFT_MIN_SETS: gratis varianten die meer sets nodig hebben (variant-id: minimaal aantal)
 */
(function () {
  var FLEX_PRODUCT_IDS = [10480845979985];
  var GIFT_MIN_SETS = { 50939377647953: 2, 54718553489745: 2 }; // gratis laptop standaard vanaf 2 sets
  var CART_CHANGE_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var busy = false;
  var timer = null;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // Gewenst aantal per cadeau: gewone cadeaus 1 per Flex, cadeaus met een minimum (laptop standaard) 1 stuk
  function targetFor(variantId, flexQty) {
    var minSets = GIFT_MIN_SETS[variantId];
    if (minSets) return flexQty >= minSets ? 1 : 0;
    return flexQty;
  }

  function updatesFor(cart) {
    if (!cart || !cart.items) return null;
    var flexQty = 0;
    cart.items.forEach(function (item) {
      if (FLEX_PRODUCT_IDS.indexOf(item.product_id) > -1) flexQty += item.quantity;
    });
    var giftLines = {};
    cart.items.forEach(function (item) {
      var isGift = item.original_price === 0 || (item.properties && item.properties._bb_gift);
      if (!isGift) return; // alleen cadeaus, betaalde producten blijven staan
      (giftLines[item.variant_id] = giftLines[item.variant_id] || []).push(item);
    });
    var updates = {}, changed = false;
    Object.keys(giftLines).forEach(function (variantId) {
      var target = targetFor(variantId, flexQty);
      giftLines[variantId].forEach(function (item, i) {
        var wanted = i === 0 ? target : 0; // eventuele dubbele regels samenvoegen in de eerste
        if (item.quantity !== wanted) { updates[item.key] = wanted; changed = true; }
      });
    });
    return changed ? updates : null;
  }

  var lastAttempt = { sig: '', time: 0 };
  function check(cart) {
    if (busy) return;
    var updates = updatesFor(cart);
    if (!updates) return;
    // Niet steeds dezelfde wijziging herhalen (bijv. als een cadeau niet genoeg voorraad heeft)
    var sig = JSON.stringify(updates);
    if (sig === lastAttempt.sig && Date.now() - lastAttempt.time < 15000) return;
    lastAttempt = { sig: sig, time: Date.now() };
    fix(updates);
  }

  function fix(updates) {
    busy = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { updates: updates };
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    nativeFetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (window.kachingCartApi && typeof kachingCartApi.refreshCart === 'function') {
          return kachingCartApi.refreshCart().catch(function () {});
        }
        if (drawer && cart.sections) render(drawer, cart);
      })
      .catch(function (e) { console.error('Blerron cart guard', e); })
      .finally(function () { setTimeout(function () { busy = false; }, 800); });
  }

  function render(drawer, cart) {
    var parse = function (html, selector) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    };
    var inner = document.getElementById('CartDrawer');
    var html = cart.sections['cart-drawer'] && parse(cart.sections['cart-drawer'], '#CartDrawer');
    if (inner && html !== null) inner.innerHTML = html;
    var bubble = document.getElementById('cart-icon-bubble');
    var bubbleHtml = cart.sections['cart-icon-bubble'] && parse(cart.sections['cart-icon-bubble'], '.shopify-section');
    if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  function load() {
    if (busy) return;
    nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(check)
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(load, 400);
  }

  // Eigen verzoeken via de originele fetch, zodat ze niet opnieuw een controle starten
  var originalFetch = window.fetch;
  function nativeFetch() { return originalFetch.apply(window, arguments); }

  // 1. Elke wijziging van de winkelwagen (thema, Kaching Cart, bundel) opvangen
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (CART_CHANGE_URL.test(url)) result.then(schedule, function () {});
    return result;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bbCartUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_CHANGE_URL.test(this.__bbCartUrl || '')) this.addEventListener('loadend', schedule);
    return xhrSend.apply(this, arguments);
  };

  // 2. Kaching Cart gebruikt soms zijn eigen fetch: controleer daarom elke seconde
  //    de winkelwagen die Kaching al in het geheugen heeft (geen extra serververzoek)
  setInterval(function () {
    if (busy || !window.kachingCartApi || typeof kachingCartApi.getCartData !== 'function') return;
    try { check(kachingCartApi.getCartData()); } catch (e) {}
  }, 1000);

  // 3. Bij het laden van elke pagina en na thema-events
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
  subscribe('cart-update', schedule);
})();
